import { defineComponent as _defineComponent } from 'vue'
import OzBaseSnackbar from 'library/v4/components/OzBaseSnackbar.vue'
import { storeToRefs } from 'pinia'
import type { QueuedGlobalSnackbarNotification } from 'pinia/global_snackbar'
import { useGlobalSnackbarStore } from 'pinia/global_snackbar'


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalSnackbar',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    topOffset: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { darkMode: boolean | 'auto', topOffset: number }



const globalSnackbarStore = useGlobalSnackbarStore()
const { snackbarArray } = storeToRefs(globalSnackbarStore)
const { executeActions } = globalSnackbarStore

function calculateSnackbarPosition(snackbarIndex: number): string {
  const actualIndex =
    snackbarIndex -
    Math.min(...snackbarArray.value.map((snackbar: QueuedGlobalSnackbarNotification) => snackbar.originalIndex))
  // 49 is the height of snackbar plus margin between snackbars
  // each subsequent snackbar is height plus margin of a snackbar from the top of the viewport plus initial gap (16px)
  return `${(snackbarArray.value.length - actualIndex) * 49 - 16 + props.topOffset}px`
}

return { __sfc: true,props, globalSnackbarStore, snackbarArray, executeActions, calculateSnackbarPosition, OzBaseSnackbar }
}

})